import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

export const Room9 = (props) => {

  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

  const handleBackHome = (e) => {
      props.onChangeRoom(0);
  }

    return(
      <div className="landing room9">
        {stars}

        <div className='logoMuseo'>
          <CommonSvgContent stringToRet="logoMuseo" />
        </div>

        <div className='collaborazione'>
          <p>In collaborazione con</p>
          <h3>INAF-Osservatorio<br />
          Astronomico<br />
          di Brera </h3>
        </div>

        <div className='agcom'>
          <ContentLanding stringToRet="agcom" />
        </div>

        <div className='logo'>
          <ContentLanding stringToRet="logo" />
          <h2><strong>TEMPO SCADUTO!</strong></h2>
          <p>Margherita Hacker, nonostante il tuo aiuto, non è riuscita a venire a capo del mistero del messaggio lasciato da Giovanni Virginio Schiaparelli. Non sappiamo se l’avvertimento rappresentasse un vero pericolo. Margherita è tornata al suo lavoro di restauratrice e si augura magari un giorno di trovare altri indizi all’interno di altri oggetti astronomici.</p>
          <p>Le missioni della NASA e dell'ESA sul pianeta Marte proseguono, giorno dopo giorno. Chissà cosa aspettarci e cosa troveremo. Continua a seguire i notiziari e gli aggiornamenti per saperne di più.</p>

          <p>Grazie per aver giocato con noi!</p>
          <p>Ci auguriamo di avervi fatto nascere comunque una scintilla di curiosità per l’affascinante storia di Giovanni Virginio Schiaparelli.</p>

          <p>Se vuoi scoprire la sua vera storia e di come sia nato il mito dei “marziani”, puoi venire a trovarci al Museo Nazionale Scienza e Tecnologia e all’Osservatorio Astronomico di Brera a Milano.</p>

          <div className="buttonsBlocks">
            <button className="btn btn-warning backTo" onClick={handleBackHome} to="/">ESCI</button>
            <Link className="btn btn-success" to="/classifica">CLASSIFICA</Link>
          </div>
        </div>

        <div className="mars">
          <ContentLanding stringToRet="mars" />
        </div>



        <p className="scopri">SCOPRI DI PIÙ</p>
        <div className="buttonsBlocks">

          <a className="btn btn-danger" target="_blank" href="https://www.museoscienza.org/">MUSEOSCIENZA.ORG</a>
          <a className="btn btn-danger" target="_blank" href="http://www.brera.inaf.it/">BRERA.INAF.IT</a>
        </div>



      </div>
    )
}
